import { fetcher } from 'services/helpers/responseHandler'

const getList = () => fetcher.get('roles')

const remove = userId => fetcher.del('users', { userId })

const edit = ({
  userId,
  position,
  fullName,
  phone,
  email,
  timeZoneName,
  isInvoiceRecipient
}) => {
  return fetcher.patch('users', {
    userId,
    position,
    fullName,
    phone: phone ? phone.replace('+', '') : null,
    email: email ? email.trim() : null,
    timeZoneName,
    isInvoiceRecipient
  })
}

const editSelf = ({ fullName, phone, email }) =>
  fetcher.patch('users/me', { fullName, phone: phone.replace('+', ''), email })

const updateRoles = data => fetcher.patch('roles', data)

const add = ({
  phone,
  email,
  fullName,
  position,
  timeZoneName,
  existingUserAccept,
  subsidiaryId,
  isAddingDuringSetup = false,
  isInvoiceRecipient
}) =>
  fetcher.post(`users`, {
    phone,
    email,
    fullName,
    position,
    timeZoneName,
    existingUserAccept,
    subsidiaryId,
    isAddingDuringSetup,
    isInvoiceRecipient
  })

const setAsInternalAdmin = ({ isInternalAdmin }) =>
  fetcher.post('users/internaladmin', { isInternalAdmin })

const updateInvoiceRecipients = users => fetcher.put('roles/recipients/invoice', users)

const getCustomerSuccessManagers = async () => await fetcher.get('users/role/Csm')

const getSalesAgents = async () => await fetcher.get('users/role/SalesAgent')

const allUsers = () => fetcher.get('users')

const updateUserRole = async ({ dashboardUserId, subsidiaryId, role }) =>
  await fetcher.post('users/role', {
    dashboardUserId,
    subsidiaryId,
    role
  })

const deleteUserRole = async ({ dashboardUserId, subsidiaryId }) =>
  await fetcher.del('users/role', {
    dashboardUserId,
    subsidiaryId
  })

const addOrUpdateNote = async data => fetcher.post('users/note', data)

const retrieveNote = async params => fetcher.get('users/note', params)

const userApi = {
  getList,
  remove,
  edit,
  add,
  editSelf,
  updateRoles,
  setAsInternalAdmin,
  updateInvoiceRecipients,
  getCustomerSuccessManagers,
  updateUserRole,
  deleteUserRole,
  getSalesAgents,
  allUsers,
  addOrUpdateNote,
  retrieveNote
}

export default userApi
